import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      void data;
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Anmeldung fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-4 grain">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-border p-8 shadow-[0_12px_40px_rgb(0,0,0,0.15)] relative">
        <div className="flex justify-center mb-6"><Logo /></div>
        <h1 className="font-heading font-bold text-xl text-charcoal text-center flex items-center justify-center gap-2">
          <Lock className="w-5 h-5 text-forest" /> Admin-Bereich
        </h1>
        <p className="text-sm text-charcoal-muted text-center mt-1">Anmeldung erforderlich</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="a-email" className="text-sm font-medium text-charcoal">E-Mail</label>
            <input id="a-email" type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 w-full rounded-md border border-input px-3.5 py-2.5 focus:outline-none focus:ring-2 focus:ring-forest/40" />
          </div>
          <div>
            <label htmlFor="a-pass" className="text-sm font-medium text-charcoal">Passwort</label>
            <input id="a-pass" type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 w-full rounded-md border border-input px-3.5 py-2.5 focus:outline-none focus:ring-2 focus:ring-forest/40" />
          </div>
          {error && <p className="text-sm text-destructive" role="alert" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-button" className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-forest px-5 py-3 text-white font-semibold hover:bg-forest-dark disabled:opacity-70 transition-colors">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
